<template>
  <div>
    <v-dialog width="90%" persistent scrollable v-model="dialogSyncDevice">
      <v-card height="90vh">
        <v-card-title class="grey lighten-2">
          <span>สถานะการซิงค์กับ Device</span>

          <v-spacer></v-spacer>

          <v-btn icon @click="handleCloseDialogSyncDevice">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-title class="d-flex align-center justify-space-between">
          <div>
            <v-badge color="error" dot :value="hasDeviceSyncing">
              <v-btn
                small
                rounded
                depressed
                :color="syncDeviceButtonType === 'syncing' ? 'primary' : ''"
                @click="handleClickButtonSyncing"
              >
                กำลังซิงค์
              </v-btn>
            </v-badge>
            <v-btn
              class="ml-3"
              small
              rounded
              depressed
              :color="syncDeviceButtonType === 'done' ? 'primary' : ''"
              @click="handleClickButtonSyncDone"
            >
              สิ้นสุดแล้ว
            </v-btn>
          </div>
          <div class="d-flex align-start">
            <div v-if="selectedSyncDeviceHardware === null" class="mr-2">
              <v-autocomplete
                :value="filterSyncDeviceHardware"
                :items="
                  hardwareList.map((hardware) => ({
                    ...hardware,
                    hardwareCodeWithTitle:
                      hardware.hardware_code + ' - ' + hardware.title_th,
                  }))
                "
                :loading="loadingHardware"
                item-text="hardwareCodeWithTitle"
                item-value="hardware_uuid"
                label="เลือก Device"
                prepend-inner-icon="mdi-filter-variant"
                clearable
                dense
                outlined
                hide-details
                style="width: 280px; background-color: white; margin-right: 5px"
                @change="handleFilterHardware($event)"
              ></v-autocomplete>
            </div>
            <div
              v-if="syncDeviceButtonType === 'done'"
              style="width: 270px"
              class="mr-2"
            >
              <v-select
                :value="filterSyncDeviceStatus"
                class="pt-0 body-2"
                :items="[
                  { id: 1, value: 'success', text: 'แสดงเฉพาะรายการที่สำเร็จ' },
                  { id: 2, value: 'fail', text: 'แสดงเฉพาะรายการที่ไม่สำเร็จ' },
                ]"
                label="สถานะการซิงค์"
                item-text="text"
                item-value="value"
                hide-details
                outlined
                dense
                clearable
                @change="handleFilterStatus($event)"
              ></v-select>
            </div>
            <div style="width: 160px">
              <v-select
                :value="itemsPerPageSyncDevice"
                class="pt-0 body-2"
                :items="[
                  { id: 1, value: 20, text: '20 รายการล่าสุด' },
                  { id: 2, value: 50, text: '50 รายการล่าสุด' },
                ]"
                item-text="text"
                item-value="value"
                hide-details
                outlined
                dense
                @change="handleChangeItemsPerPageSyncDevice($event)"
              ></v-select>
            </div>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-5">
          <v-data-table
            :headers="[
              {
                text: 'วันที่ - เวลา',
                sortable: false,
                align: 'start',
                value: 'datetime',
                width: '20%',
              },
              {
                text: 'Device',
                sortable: false,
                value: 'device',
                width: '20%',
              },
              {
                text: 'คำสั่งที่ซิงค์',
                sortable: false,
                value: 'command',
                width: '20%',
              },
              {
                text: 'ข้อความ',
                sortable: false,
                value: 'message',
                width: '25%',
              },
              {
                text: 'สถานะ',
                sortable: false,
                value: 'status',
                width: '15%',
              },
            ]"
            :items="responseSyncDevice"
            :items-per-page="itemsPerPageSyncDevice"
            :loading="isFetchingSyncDevice"
            class="elevation-1"
            hide-default-footer
            :item-class="classRow"
            @click:row="handleClickRow"
          >
            <template v-slot:item.datetime="{ item }">
              <v-list-item two-line class="pa-0">
                <v-list-item-content class="py-0">
                  <v-list-item-title style="font-size: 14px">
                    <v-skeleton-loader
                      v-if="
                        (syncDeviceButtonType === 'syncing' &&
                          item.created_at === null) ||
                        (syncDeviceButtonType === 'done' &&
                          item.done_datetime === null)
                      "
                      type="heading"
                      tile
                    ></v-skeleton-loader>
                    <div v-else>
                      <span v-if="syncDeviceButtonType === 'syncing'">
                        {{ item.created_at | dateTimeFormat }}
                      </span>
                      <span v-else>
                        {{ item.done_datetime | dateTimeFormat }}
                      </span>
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    <v-skeleton-loader
                      v-if="
                        (syncDeviceButtonType === 'syncing' &&
                          item.created_at === null) ||
                        (syncDeviceButtonType === 'done' &&
                          item.done_datetime === null)
                      "
                      type="text"
                      tile
                    ></v-skeleton-loader>
                    <div v-else>
                      <span v-if="syncDeviceButtonType === 'syncing'">
                        {{ dateTimeFromNow(item.created_at) }}
                      </span>
                      <span v-else>
                        {{ dateTimeFromNow(item.done_datetime) }}
                      </span>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:item.command="{ item }">
              <v-chip label outlined>{{ item.command }}</v-chip>
            </template>
            <template v-slot:item.device="{ item }">
              <v-list-item two-line class="pa-0">
                <v-list-item-content>
                  <v-list-item-title style="font-size: 14px">
                    {{ item.hardware.hardware_code }} -
                    {{ item.hardware.title_th }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption"
                    >Device รุ่น : {{ item.hardware.hardware_model.title }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                v-if="syncDeviceButtonType === 'syncing'"
                color="blue lighten-1"
                label
                outlined
                style="font-size: 14px"
              >
                {{
                  item.notice_datetime
                    ? 'รอ Device ดำเนินการ'
                    : 'กำลังติดต่อ Device'
                }}
              </v-chip>
              <v-chip
                v-else
                :color="item.is_success ? 'green lighten-1' : 'red lighten-1'"
                label
                outlined
                style="font-size: 14px"
              >
                {{ item.is_success ? 'สำเร็จ' : 'ไม่สำเร็จ' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <DialogSyncDeviceResponseData
      :dialogSyncDeviceResponseData="dialogSyncDeviceResponseData"
      :responseData="responseData"
      @onCloseDialogSyncDeviceResponseData="
        dialogSyncDeviceResponseData = false
      "
    />
  </div>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

import DialogSyncDeviceResponseData from '@/components/DialogSyncDeviceResponseData.vue'

export default {
  name: 'DialogSyncDevice',
  components: {
    DialogSyncDeviceResponseData,
  },
  data() {
    return {
      dialogSyncDeviceResponseData: false,
      responseData: {},
      loadingHardware: false,
      hardwareList: [],
    }
  },
  filters: {
    dateTimeFormat: function (value) {
      if (!value) return
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
  },
  computed: {
    dialogSyncDevice() {
      return this.$store.state.hardware.dialogSyncDevice
    },
    responseSyncDevice() {
      return this.$store.state.hardware.responseSyncDevice
    },
    hasDeviceSyncing() {
      return !!this.responseSyncDevice.length
    },
    syncDeviceButtonType() {
      return this.$store.state.hardware.syncDeviceButtonType
    },
    filterSyncDeviceStatus() {
      return this.$store.state.hardware.filterSyncDeviceStatus
    },
    filterSyncDeviceHardware() {
      return this.$store.state.hardware.filterSyncDeviceHardware
    },
    itemsPerPageSyncDevice() {
      return this.$store.state.hardware.itemsPerPageSyncDevice
    },
    isFetchingSyncDevice() {
      return this.$store.state.hardware.isFetchingSyncDevice
    },
    selectedSyncDeviceHardware() {
      return this.$store.state.hardware.selectedSyncDeviceHardware
    },

    deviceInfoTranslate() {
      return this.$store.state.hardware.deviceInfoTranslate
    },
    employeeInfoTranslate() {
      return this.$store.state.hardware.employeeInfoTranslate
    },
    employeeListTranslate() {
      return this.$store.state.hardware.employeeListTranslate
    },
  },
  watch: {
    dialogSyncDevice(value) {
      if (value && this.selectedSyncDeviceHardware === null) {
        this.fetchApiHardwares()
      }
    },
  },
  methods: {
    ...mapActions({
      fetchDeviceInfoTranslate: 'hardware/fetchDeviceInfoTranslate',
      fetchEmployeeInfoTranslate: 'hardware/fetchEmployeeInfoTranslate',
      fetchEmployeeListTranslate: 'hardware/fetchEmployeeListTranslate',
      fetchHardwares: 'hardware/fetchHardwares',
    }),
    async fetchApiHardwares() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.loadingHardware = true

        await this.fetchHardwares({
          params: {
            company_uuid,
            dpc: 'hardware-to-list-hardware',
          },
        })

        this.hardwareList = [...this.$store.state.hardware.hardwares]
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingHardware = false
      }
    },
    handleCloseDialogSyncDevice() {
      this.$store.commit('hardware/SET_SELECTED_SYNC_DEVICE_HARDWARE', null)
      this.$store.commit('hardware/SET_FILTER_SYNC_DEVICE_HARDWARE', null)
      this.$store.commit('hardware/SET_FILTER_SYNC_DEVICE_STATUS', null)
      this.$store.commit('hardware/SET_DIALOG_SYNC_DEVICE', false)

      this.$emit('onCloseDialogSyncDevice')
    },
    handleClickButtonSyncing() {
      if (this.syncDeviceButtonType === 'syncing') return

      this.$store.commit('hardware/SET_SYNC_DEVICE_BUTTON_TYPE', 'syncing')

      this.$emit('onClickButtonSyncing')
    },
    handleClickButtonSyncDone() {
      if (this.syncDeviceButtonType === 'done') return

      this.$store.commit('hardware/SET_SYNC_DEVICE_BUTTON_TYPE', 'done')

      this.$emit('onClickButtonSyncDone')
    },
    handleFilterStatus(value) {
      this.$store.commit('hardware/SET_FILTER_SYNC_DEVICE_STATUS', value)

      this.$emit('onChangeSyncDeviceFilterStatus')
    },
    handleFilterHardware(value) {
      this.$store.commit('hardware/SET_FILTER_SYNC_DEVICE_HARDWARE', value)

      this.$emit('onChangeSyncDeviceFilterHardware')
    },
    handleChangeItemsPerPageSyncDevice(value) {
      this.$store.commit('hardware/SET_ITEMS_PER_PAGE_SYNC_DEVICE', value)

      this.$emit('onChangeItemsPerPageSyncDevice')
    },
    classRow() {
      if (this.syncDeviceButtonType === 'done') return 'cursor-pointer'
    },
    async handleClickRow(row) {
      if (this.syncDeviceButtonType === 'syncing') return

      try {
        if (row.sync_version === 'v2') {
          this.responseData = {
            command: row.command,
            hardware: row.hardware,
            is_success: row.is_success,
            response_json: {
              message: row.command,
              result: row.is_success ? 'Success' : 'Failed',
            },
            sync_version: row.sync_version,
          }
          this.dialogSyncDeviceResponseData = true
          return
        }

        this.$store.state.loading = true

        if (row.command === 'get_device_info') {
          await this.fetchDeviceInfoTranslate()
        }

        if (row.command === 'get_employee') {
          await this.fetchEmployeeInfoTranslate()
        }

        if (row.command === 'get_employee_list') {
          await this.fetchEmployeeListTranslate()
        }

        if (
          ['get_device_info', 'get_employee'].includes(row.command) &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            row.hardware?.hardware_model?.hardware_model_code
          ) &&
          row.is_success
        ) {
          const data = row.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this[
                  row.command === 'get_device_info'
                    ? 'deviceInfoTranslate'
                    : 'employeeInfoTranslate'
                ]?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) => {
                return {
                  key: subItem.key,
                  key_name:
                    this[
                      row.command === 'get_device_info'
                        ? 'deviceInfoTranslate'
                        : 'employeeInfoTranslate'
                    ]?.keys[subItem.key]?.th ||
                    subItem.key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: subItem.value.toString().trim(), // fix int and space
                  type: subItem.type,
                }
              }),
            }
          })

          this.responseData = {
            command: row.command,
            hardware: row.hardware,
            is_success: row.is_success,
            response_json: data,
          }
          this.dialogSyncDeviceResponseData = true
          return
        }

        if (
          ['get_employee_list'].includes(row.command) &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            row.hardware?.hardware_model?.hardware_model_code
          ) &&
          row.is_success
        ) {
          const data = row.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.employeeListTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) =>
                Object.entries(subItem).map(([key, obj]) => ({
                  key,
                  key_name:
                    this.employeeListTranslate?.keys[key]?.th ||
                    key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: obj.value,
                  type: obj.type,
                }))
              ),
            }
          })

          this.responseData = {
            command: row.command,
            hardware: row.hardware,
            is_success: row.is_success,
            response_json: data,
          }
          this.dialogSyncDeviceResponseData = true
          return
        }

        if (
          [
            'get_employee_list',
            'get_access_authority_list',
            'get_last_update',
          ].includes(row.command) &&
          row.is_success
        ) {
          let response_json
          if (
            row.response_json.length > 0 &&
            row.response_json[0]['Last Updated'] === undefined
          ) {
            response_json = row.response_json
              .map((item) => ({ fid: item, ['Last Updated']: null }))
              .sort((a, b) => a.fid.localeCompare(b.fid))
          } else if (row.response_json.length) {
            response_json = row.response_json.sort((a, b) =>
              a.fid.localeCompare(b.fid)
            )
          } else {
            response_json = row.response_json
          }

          this.responseData = {
            command: row.command,
            hardware: row.hardware,
            is_success: row.is_success,
            response_json,
          }
          this.dialogSyncDeviceResponseData = true
          return
        }

        if (['set_employee'].includes(row.command) && row.is_success) {
          this.responseData = {
            command: row.command,
            hardware: row.hardware,
            is_success: row.is_success,
            response_json: row.response_json?.length
              ? row.response_json[0]
              : {
                  message: row.message
                    ? row.message
                    : 'Employee data updated successfully',
                  result: 'Success',
                },
          }
          this.dialogSyncDeviceResponseData = true
          return
        }

        if (
          ['get_employee', 'get_employee_list', 'get_device_info'].includes(
            row.command
          ) &&
          ['acu01r', 'cru77rf', 'vf1000r'].includes(
            row.hardware?.hardware_model?.hardware_model_code
          ) &&
          row.is_success === false
        ) {
          const data = row.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this[
                  row.command === 'get_device_info'
                    ? 'deviceInfoTranslate'
                    : 'employeeInfoTranslate'
                ]?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) => {
                return {
                  key: subItem.key,
                  key_name:
                    this[
                      row.command === 'get_device_info'
                        ? 'deviceInfoTranslate'
                        : 'employeeInfoTranslate'
                    ]?.keys[subItem.key]?.th ||
                    subItem.key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: subItem.value.toString().trim(), // fix int and space
                  type: subItem.type,
                }
              }),
            }
          })

          this.responseData = {
            command: row.command,
            hardware: row.hardware,
            is_success: row.is_success,
            response_json: data,
          }
          this.dialogSyncDeviceResponseData = true
          return
        }

        this.responseData = {
          command: row.command,
          hardware: row.hardware,
          is_success: row.is_success,
          response_json: row.response_json?.length
            ? row.response_json[0]
            : row.response_json
            ? row.response_json
            : {
                message: row.command,
                result: row.is_success ? 'Success' : 'Failed',
              },
        }
        this.dialogSyncDeviceResponseData = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    dateTimeFromNow(value) {
      if (!value) return
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },
}
</script>
